<template>
  <el-dialog
    append-to-body
    :visible.sync="innerVisible"
    :title="title"
    width="400px"
    class="station-edit-dialog"
    :close-on-click-modal="false"
  >
    <div v-if="innerVisible" class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form label-width="110px" label-position="left">
        <el-form-item :label="$t('CargoMsg.Cargo_SequenceNumber')">
          <el-input-number v-model="form.serialNumber" no="serialNumber" :max="999999" :min="1" controls-position="right" style="width: 200px;" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.city.code')" required>
          <el-input v-model="form.code" v-uppercase no="code" :disabled="!isAddedFromTemplate" style="width: 200px" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.city.chineseName')">
          <el-input v-model="form.chineseName" v-uppercase no="chineseName" style="width: 200px" />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.city.englishName')" required>
          <el-input v-model="form.englishName" v-uppercase no="englishName" style="width: 200px" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_ExchangeCode')">
          <el-input v-model="form.interchangeCode" no="interchangeCode" :disabled="!isAddedFromTemplate" style="width: 200px" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_IsoCode')">
          <el-input v-model="form.isoCode" no="isoCode" :disabled="!isAddedFromTemplate" style="width: 200px" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_CountryRegion')">
          <cargo-advance-select
            no="countryCode"
            :select-type="selectTypeNames.basic_data_Country"
            :cache="false"
            filterable
            :callback-params="{key:'countryCode'}"
            callback-method-type="value"
            :default-value="form.countryCode"
            :static-options="countryList"
            style="width:200px;"
            @parentCallBack="selectCargoItem"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Region')">
          <cargo-advance-select
            no="region"
            :select-type="selectTypeNames.basic_data_Region"
            :show-custom-label-in-option="true"
            :callback-params="{key:'region'}"
            callback-method-type="value"
            :default-value="form.region"
            style="width: 200px"
            @parentCallBack="selectCargoItem"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_CityName')">
          <el-input v-model="form.cityName" no="cityName" disabled style="width: 200px;margin-right: 5px" />
          <el-button no="cityClickHandler" type="primary" @click="cityClickHandler">...</el-button>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
      <el-button no="cancel" @click="visible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
    <location-search-dialog
      :visible.sync="cityDialogVisible"
      @addCallBack="selectLocalHandler"
      @close="cityDialogVisible=false"
    />
  </el-dialog>
</template>

<script>
import { getCountryList } from '@/api/country'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import LocationSearchDialog from '@/views/cargo/v0/Information/components/LocationSearchDialog'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as railwayStationApi from '@/api/basicData/railwayStation'

export default {
  name: 'StationEditDialog',
  components: { LocationSearchDialog, CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: true },
    railwayStation: { type: Object, default: null }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      form: {
        uuid: '',
        serialNumber: '',
        code: '',
        chineseName: '',
        englishName: '',
        interchangeCode: '',
        isoCode: '',
        countryCode: '',
        cityName: '',
        region: ''
      },
      cityDialogVisible: false,
      location: null,
      isAddedFromTemplate: this.$store.getters.tenantId === 1, // WALLTECH_PLATFORM
      countryList: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (newVal && this.railwayStation) {
        Object.assign(this.form, this.railwayStation)
      }
      this.$emit('update:visible', newVal)
    }
  },
  beforeCreate() {
    const self = this
    getCountryList().then(res => {
      self.countryList = res.data
    })
  },
  methods: {
    selectCargoItem(item) {
      this.form[item.key] = item.value
    },
    cityClickHandler() {
      this.cityDialogVisible = true
    },
    selectLocalHandler(location) {
      this.location = location
      this.form.cityName = location.englishName
    },
    save() {
      const self = this
      const form = self.form
      const railwayStation = {}
      railwayStation.uuid = form.uuid
      railwayStation.serialNumber = form.serialNumber
      railwayStation.englishName = form.englishName
      railwayStation.chineseName = form.chineseName
      railwayStation.countryCode = form.countryCode
      railwayStation.region = form.region
      railwayStation.interchangeCode = form.interchangeCode
      railwayStation.code = form.code
      if (this.location) {
        railwayStation.cityName = form.cityName
        railwayStation.cityCode = this.location.code
      }
      if (this.isAddedFromTemplate) {
        if (!railwayStation.code) {
          this.$message.warning(this.$t('Information.CodeCannotBeEmpty'))
          return
        }
        if (!railwayStation.englishName) {
          this.$message.warning(this.$t('Information.EnglishNameCannotBeEmpty'))
          return
        }
        railwayStation.isoCode = form.isoCode
        railwayStation.interchangeCode = form.interchangeCode
      }
      if (this.isAddedFromTemplate && !railwayStation.uuid) {
        railwayStationApi.savePlatformRailwayStation(railwayStation).then(resp => {
          this.$emit('saveCallBack', resp.data)
          this.savePortsHandler()
        })
      } else {
        railwayStationApi.save(railwayStation).then(resp => {
          this.$emit('saveCallBack', resp.data)
          this.savePortsHandler()
        })
      }
    },
    savePortsHandler() {
      // todo CacheManager.getInstance().loadCache(RailwayStation.CODE_NAME);
      this.$message.success(this.$t('common.tips.saveSuccess'))
      this.$emit('close')
    }
  }
}
</script>

<style>
  .station-edit-dialog .el-input-number .el-input input {
    text-align: right;
  }
</style>
